import React, { Component } from 'react';
import { Progress } from 'reactstrap';
import './index.css'
import Aux from '../Hoc';


class ProgressBar extends Component {
    render() {
        return (
            <div className="d-flex flex-row ">
                <div className="col-lg-9 col-md-8">
                    <Progress className={this.props.height ? "MultiRaterProgress" : "singleRaterProgress"} value={this.props.value} max={this.props.max} striped={this.props.striped} 
                     />
                </div>
                <div className="col-lg-3 col-md-4 px-md-0">
                    <p className="mb-0"> {this.props.value} out of {this.props.max} </p>
                </div>
            </div>



        )
    }
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/_components/common/ProgressBar/index.jsx